import React, { Fragment, useContext } from 'react';

/* Context */
import { VehicleOverviewContext } from 'js/context';

/* Atoms */
import { Button } from 'js/components/atoms';

/* Utilities */
import { trans } from 'js/utilities';

/* Symbols */
import close from 'symbols/close.svg';

const numberFormat = new Intl.NumberFormat();

export default function VehicleOverviewActiveFilters({ filters }) {
    const { resetFilters } = useContext(VehicleOverviewContext);

    return (
        <div className="row gutters-2 gutters-xl-4 align-items-baseline">
            <div className="col-12 col-xl">
                <div className='d-flex flex-wrap gap-1'>
                    {filters.map((filterGroup) => {
                        const filterGroupPath = `${filters?.indexOf(filterGroup)}`;

                        return (
                            <Fragment key={filterGroupPath}>
                                {filterGroup.filters.map((filter) => {
                                    const filterPath = `${filterGroupPath}.filters.${filterGroup.filters.indexOf(filter)}`;

                                    if (filter?.filterKey === 'partnervoertuig') return;

                                    return (
                                        <ActiveFilter
                                            key={filterPath}
                                            filter={filter}
                                            path={filterPath}
                                        />
                                    )
                                })}
                            </Fragment>
                        );
                    })}
                </div>
            </div>
            <div className="col-12 col-xl-auto">
                <button className='btn btn-none' onClick={resetFilters}>
                    <span className='btn__text text-primary text-transform-none'>{trans(`sulu.content_block.vehicle_overview.filter.reset_filters`, {}, '')}</span>
                </button>
            </div>
        </div>

    );
}

const ActiveFilter = ({ filter, path }) => {
    const { updateFilters } = useContext(VehicleOverviewContext);

    if (filter.viewType === 'multi_select') {
        return (
            <>
                {filter.choices.filter((choice) => choice.active).map((choice) => {
                    const choicePath = `${path}.choices.${filter.choices.indexOf(choice)}`;

                    return (
                        <Fragment key={choicePath}>
                            <ActiveFilterChip
                                text={`
                                    ${trans(`sulu.content_block.vehicle_overview.filter.key.${filter.filterKey}.prefix`, {}, '')}
                                    ${choice.name}
                                    ${trans(`sulu.content_block.vehicle_overview.filter.key.${filter.filterKey}.suffix`, {}, '')}
                                `}
                                onClick={() => updateFilters(`${choicePath}.active`, false)}
                            />

                            {choice.filters.map((filter) => {
                                const filterPath = `${choicePath}.filters.${choice.filters.indexOf(filter)}`;

                                return (
                                    <ActiveFilter
                                        key={filterPath}
                                        filter={filter}
                                        path={filterPath}
                                    />
                                )
                            })}
                        </Fragment>
                    );
                })}
            </>
        );
    }

    if (filter.viewType === 'open_input_range_list') {
        return (
            <>
                {filter.selectedMinValue !== filter.minValue ? (
                    <ActiveFilterChip
                        key={`${path}.selectedMinValue`}
                        text={`
                            ${trans(`sulu.content_block.vehicle_overview.filter.key.${filter.filterKey}.min_prefix`, {}, '')}
                            ${numberFormat.format(filter.selectedMinValue)}
                            ${trans(`sulu.content_block.vehicle_overview.filter.key.${filter.filterKey}.min_suffix`, {}, '')}
                        `}
                        onClick={() => updateFilters(`${path}.selectedMinValue`, filter.minValue)}
                    />
                ) : null}
                {filter.selectedMaxValue !== filter.maxValue ? (
                    <ActiveFilterChip
                        key={`${path}.selectedMaxValue`}
                        text={`
                            ${trans(`sulu.content_block.vehicle_overview.filter.key.${filter.filterKey}.max_prefix`, {}, '')}
                            ${numberFormat.format(filter.selectedMaxValue)}
                            ${trans(`sulu.content_block.vehicle_overview.filter.key.${filter.filterKey}.max_suffix`, {}, '')}
                        `}
                        onClick={() => updateFilters(`${path}.selectedMaxValue`, filter.maxValue)}
                    />
                ) : null}
            </>
        );
    }

    if (filter.viewType === 'range_list') {
        return (
            <>
                {filter.selectedMinValue !== filter.minValues[0] ? (
                    <ActiveFilterChip
                        key={`${path}.selectedMinValue`}
                        text={`${trans(`sulu.content_block.vehicle_overview.filter.from`, {}, '')} ${filter.selectedMinValue}`}
                        onClick={() => updateFilters(`${path}.selectedMinValue`, filter.minValues[0])}
                    />
                ) : null}
                {filter.selectedMaxValue !== filter.maxValues[filter.maxValues.length - 1] ? (
                    <ActiveFilterChip
                        key={`${path}.selectedMaxValue`}
                        text={`${trans(`sulu.content_block.vehicle_overview.filter.till`, {}, '')} ${filter.selectedMaxValue}`}
                        onClick={() => updateFilters(`${path}.selectedMaxValue`, filter.maxValues[filter.maxValues.length - 1])}
                    />
                ) : null}
            </>
        );
    }

    return null;
}

const ActiveFilterChip = ({ ...props }) => {
    return (
        <Button
            theme='chip'
            icon={{
                size: 16,
                url: close,
            }}
            {...props}
        />
    )
}
